export const GamePictures = {
  singlePerson: {
    x: 500,
    y: 0
  },
};

GamePictures.showCat = () => {
  $gameScreen.showPicture(10, "cat", 0, 870, 370, 75, 75, 255, 0);
}

GamePictures.showSinglePersonElem = (pictureId, pictureName) => {
  $gameScreen.showPicture(pictureId, pictureName, 0, GamePictures.singlePerson.x, GamePictures.singlePerson.y, 100, 100, 255, 0);
}

GamePictures.showPersonElemWithX = (pictureId, pictureName, x) => {
  $gameScreen.showPicture(pictureId, pictureName, 0, x, 0, 100, 100, 255, 0);
}

GamePictures.clear = () => {
  $gameScreen.clearPictures();
}

GamePictures.erase = (pictureId) => {
  $gameScreen.erasePicture(pictureId);
}

GamePictures.move = (picturesNumb, x, clear) => {
  for (let i = 1; i <= picturesNumb; i++) {
    $gameScreen.movePicture(i, 0, x, 0, 100, 100, 255, 0, 45);
  }
  $gameMap._interpreter.wait(60);
  if(clear) {
    setTimeout(() => {
      GamePictures.clear();
    }, 1000);
  }
}

GamePictures.moveRight = (picturesNumb, clear = true) => {
  GamePictures.move(picturesNumb, 1500, clear);
}

GamePictures.moveLeft = (picturesNumb, clear = true) => {
  GamePictures.move(picturesNumb, -500, clear);
}

GamePictures.showPicture = (pictureId, pictureName) => {
  $gameScreen.showPicture(pictureId, pictureName, 0, 0, 0, 100, 100, 255, 0);
}

GamePictures.showRubinaAndEliana = () => {
  for (let i = 1; i <= 3; i++) {
    $gameScreen.movePicture(i, 0, 500, 0, -100, 100, 255, 0, 45);
  }

  for (let i = 5; i <= 7; i++) {
    $gameScreen.movePicture(i, 0, 700, 0, 100, 100, 255, 0, 45);
  }

  $gameMap._interpreter.wait(60);
}

export const RandomChick = {
  currentChickNumber: -1,
  currentChick: null,
  currentSexScene: '',
  pictureId: {
    body: 1,
    face: 2,
    clothes: 3
  },
  sexScenes: [
    'vaginal_sex',
    'anal_sex',
    'sideway_vaginal_sex',
    'sideway_anal_sex',
    'titfuck',
  ],
  randomChicks: [
    {
      body: 'strawberrybod',
      clothes: 'strawberrycloth',
      sex: {
        vaginal_sex: 'sexsistersstrawc',
        anal_sex: 'sexsistersstrawb',
        sideway_vaginal_sex: 'ss3strawvag',
        sideway_anal_sex: 'ss3strawanal',
        titfuck: 'bjs',
      },
      cum_scene: {
        vaginal_sex: ['sexsistersstrawa', 'sexsisterscumc'],
        anal_sex: ['sexsistersstrawa', 'sexsisterscumc'],
        sideway_vaginal_sex: 'ss3strawcumanal',
        sideway_anal_sex: 'ss3strawcumvag',
        titfuck: 'bjcumfull'
      },
      face: {
        normal: 'strawberryfacea',
        happy: 'strawberryfaceb',
        flirt: 'strawberryfacec',
        sad: 'strawberryfaced',
        angry: 'strawberryfacee',
      }
    },
    {
      body: 'peppermintbod',
      clothes: 'peppermintcloth',
      sex: {
        vaginal_sex: 'sexsistersapepperc',
        anal_sex: 'sexsistersapepperb',
        sideway_vaginal_sex: 'ss3peppervag',
        sideway_anal_sex: 'ss3pepperanal',
        titfuck: 'bjp',
      },
      cum_scene: {
        vaginal_sex: ['sexsistersapeppera', 'sexsisterscuma'],
        anal_sex: ['sexsistersapeppera', 'sexsisterscuma'],
        sideway_vaginal_sex: 'ss3peppercumvag',
        sideway_anal_sex: 'ss3peppercumanal',
        titfuck: 'bjcumflat'
      },
      face: {
        normal: 'peppermintfacee',
        happy: 'peppermintfaced',
        flirt: 'peppermintfacec',
        sad: 'peppermintfaceb',
        angry: 'peppermintfacea',
      }
    },
    {
      body: 'licorbod',
      clothes: 'licorcloth',
      sex: {
        vaginal_sex: 'sexsistersalicc',
        anal_sex: 'sexsistersalicb',
        sideway_vaginal_sex: 'ss3licorvag',
        sideway_anal_sex: 'ss3licoranal',
        titfuck: 'bjl',
      },
      cum_scene: {
        vaginal_sex: ['sexsistersalica', 'sexsisterscuma'],
        anal_sex: ['sexsistersalica', 'sexsisterscuma'],
        sideway_vaginal_sex: 'ss3licorcumvag',
        sideway_anal_sex: 'ss3licorcumanal',
        titfuck: 'bjcumflat'
      },
      face: {
        normal: 'licorfacee',
        happy: 'licorfaced',
        flirt: 'licorfacec',
        sad: 'licorfaceb',
        angry: 'licorfacea',
      }
    },
    {
      body: 'coffebod',
      clothes: 'coffecloth',
      sex: {
        vaginal_sex: 'sexsisterscofc',
        anal_sex: 'sexsisterscofb',
        sideway_vaginal_sex: 'ss3coffvag',
        sideway_anal_sex: 'ss3coffanal',
        titfuck: 'bjcf',
      },
      cum_scene: {
        vaginal_sex: ['sexsisterscofa', 'sexsisterscumc'],
        anal_sex: ['sexsisterscofa', 'sexsisterscumc'],
        sideway_vaginal_sex: 'ss3coffcumvag',
        sideway_anal_sex: 'ss3coffcumanal',
        titfuck: 'bjcumfull'
      },
      face: {
        normal: 'coffefacee',
        happy: 'coffefaced',
        flirt: 'coffefacec',
        sad: 'coffefaceb',
        angry: 'coffefacea',
      }
    },
    {
      body: 'cinnbody',
      clothes: 'cinncloth',
      sex: {
        vaginal_sex: 'sexsistersacinc',
        anal_sex: 'sexsistersacinb',
        sideway_vaginal_sex: 'ss3cinvag',
        sideway_anal_sex: 'ss3cinanal',
        titfuck: 'bjc',
      },
      cum_scene: {
        vaginal_sex: ['sexsistersacina', 'sexsisterscumb'],
        anal_sex: ['sexsistersacina', 'sexsisterscumb'],
        sideway_vaginal_sex: 'ss3cincumvag',
        sideway_anal_sex: 'ss3cincumanal',
        titfuck: 'bjcumfull2'
      },
      face: {
        normal: 'cinnfacee',
        happy: 'cinnfaced',
        flirt: 'cinnfacec',
        sad: 'cinnfaceb',
        angry: 'cinnfacea',
      }
    }
  ]
};

RandomChick.hasPickedUp = () => {
  if(Yosemite.McManager.getCharisma() < 7 || !EventStateService.secondChapterIntro) {
   return false;
  }

  const pickupChance = Math.random();
  return pickupChance < 0.85;
}

RandomChick.showRandomChick = () => {
  RandomChick.currentChickNumber = Yosemite.Core.generateRandomNum(0, RandomChick.randomChicks.length - 1);
  RandomChick.currentChick = RandomChick.randomChicks[RandomChick.currentChickNumber];

  GamePictures.showSinglePersonElem(RandomChick.pictureId.body, RandomChick.currentChick.body);
  GamePictures.showSinglePersonElem(RandomChick.pictureId.face, RandomChick.currentChick.face.normal);
  GamePictures.showSinglePersonElem(RandomChick.pictureId.clothes, RandomChick.currentChick.clothes);
}

RandomChick.showFace = (faceName) => {
  GamePictures.showSinglePersonElem(RandomChick.pictureId.face, RandomChick.currentChick.face[faceName]);
}

RandomChick.showSexScene = () => {
  const randomNumber = Yosemite.Core.generateRandomNum(0, RandomChick.sexScenes.length - 1);
  RandomChick.currentSexScene = RandomChick.sexScenes[randomNumber];
  GamePictures.showPicture(1, RandomChick.currentChick.sex[RandomChick.currentSexScene]);
}

RandomChick.showCumScene = () => {
  if(RandomChick.currentSexScene === 'vaginal_sex' || RandomChick.currentSexScene === 'anal_sex') {
    GamePictures.showPicture(1, RandomChick.currentChick.cum_scene[RandomChick.currentSexScene][0]);
    GamePictures.showPicture(2, RandomChick.currentChick.cum_scene[RandomChick.currentSexScene][1]);
  } else if(RandomChick.currentSexScene === 'titfuck') {
    GamePictures.showPicture(2, RandomChick.currentChick.cum_scene[RandomChick.currentSexScene]);
  } else {
    GamePictures.showPicture(1, RandomChick.currentChick.cum_scene[RandomChick.currentSexScene]);
  }
}

export const SamanthaPictures = {
  body: 'hooker_nude',
  clothes: {
    halfNaked: 'hooker_half_clothes',
    type1: 'hooker_full_clothes',
    type2: 'hooker_full_clothes2',
    type3: 'hooker_full_clothes3'
  },
  face: {
    angry: 'hooker_angry',
    angry2: 'hooker_angry2',
    flirt: 'hooker_flirt',
    happy: 'hooker_happy',
    laugh: 'hooker_laugh',
    sad: 'hooker_sad',
    normal: 'hooker_nude'
  }
};

SamanthaPictures.show = (clothesType = 'type1') => {
  GamePictures.showSinglePersonElem(1, SamanthaPictures.body);
  GamePictures.showSinglePersonElem(2, SamanthaPictures.clothes[clothesType]);
}

SamanthaPictures.showFace = (faceName = 'normal') => {
  const pictureId = (faceName === 'normal') ? 1 : 3;
  if(pictureId === 1) GamePictures.erase(3);
  GamePictures.showSinglePersonElem(pictureId, SamanthaPictures.face[faceName]);
}

SamanthaPictures.showFaceSad = () => {
  GamePictures.showSinglePersonElem(3, SamanthaPictures.face.sad);
}

SamanthaPictures.showFromLeft = () => {
  $gameScreen.showPicture(1, SamanthaPictures.body, 0, -1500, 0, 100, 100, 255, 0);
  $gameScreen.showPicture(2, SamanthaPictures.clothes.type3, 0, -1500, 0, 100, 100, 255, 0);

  for (let i = 1; i <= 3; i++) {
    $gameScreen.movePicture(i, 0, 500, 0, 100, 100, 255, 0, 45);
  }

  $gameMap._interpreter.wait(60);
}

export const SofiaPictures = {
  body: 'sofia_base',
  clothes: {
    beach_suit: 'sofia_beach_suit',
    dress: 'sofia_dress',
    stocking: 'sofia_stock',
    glasses: 'sofia_glasses'
  },
  face: {
    angry: 'sofia_face_angry',
    flirt: 'sofia_face_flirt',
    happy: 'sofia_face_happy',
    normal: 'sofia_base'
  }
}

SofiaPictures.show = () => {
  GamePictures.showSinglePersonElem(1, SofiaPictures.body);
  GamePictures.showSinglePersonElem(3, SofiaPictures.clothes.dress);
  GamePictures.showSinglePersonElem(4, SofiaPictures.clothes.glasses);
}

export const RubinaPictures = {
  body: {
    body1: ['rubina_body1'],
    body2: ['rubina_body2'],
    body3: ['rubina_body3', 'rubina_arm1'],
    body4: ['rubina_body4'],
    body5: ['rubina_body5'],
    body6: ['rubina_body6', 'rubina_arm2']
  },
  arms: {
    normalArm: 'rubina_arm1',
    devilArm: 'rubina_arm2'
  },
  clothes: {
    clothing1: 'rubina_clothing1',
    clothing2: 'rubina_clothing2',
    clothing3: 'rubina_clothing3',
    clothing4: 'rubina_clothing4'
  },
  face: {
    angry: 'rubina_face_mad',
    flirt: 'rubina_face_flirt',
    happy: 'rubina_face_happy',
    smile: 'rubina_face_smile',
    sad: 'rubina_face_upset',
    normal: 'rubina_face_calm'
  },
  horns: 'rubina_horns',
  devilMode: false,
}

RubinaPictures.show = () => {
  GamePictures.showSinglePersonElem(1, RubinaPictures.body.body1[0]);
  GamePictures.showSinglePersonElem(2, RubinaPictures.face.normal);
  GamePictures.showSinglePersonElem(3, RubinaPictures.clothes.clothing2);
}

RubinaPictures.showFace = (faceName = 'normal') => {
  GamePictures.showSinglePersonElem(2, RubinaPictures.face[faceName]);
}

export const ElianaPictures = {
  body: {
    body1: 'eliana_body1',
    body2: 'eliana_body2',
    body3: 'eliana_body4',
    body4: 'eliana_body5'
  },
  clothes: {
    balerine: 'eliana_clothing_balerine',
    clothing1: 'eliana_clothing1',
    clothing2: 'eliana_clothing2',
    clothing3: 'eliana_clothing3',
    clothing4: 'eliana_clothing4'
  },
  face: {
    angry: 'eliana_face_angry',
    annoyed: 'eliana_face_annoyed',
    curious: 'eliana_face_curious',
    derp: 'eliana_face_derp',
    laugh: 'eliana_face_laugh',
    pissed: 'eliana_face_pissed',
    sad: 'eliana_face_sad',
    smile: 'eliana_face_smile',
    upset: 'eliana_face_upset',
    normal: 'eliana_face_calm'
  }
}
